import {Rating} from '@mui/material';

export default Rating;
